export type FeatureFlagKey =
  | 'chat'
  | 'workflows'
  | 'remoteapp'
  | 'audit'
  | 'agent'
  | 'settings'
  | 'usage';

export type FeatureFlags = Record<FeatureFlagKey, boolean>;

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  chat: true,
  workflows: false,
  remoteapp: false,
  audit: false,
  agent: false,
  settings: false,
  usage: false,
};
